import { Alert } from '@/components/ui/alert';
import { Button, VStack } from '@chakra-ui/react';
import { WarningTriangle } from 'iconoir-react';
import { useTranslation } from 'react-i18next';

interface DisplayRightsReplaceNoticeProps {
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * The explicit gate before replacing terms the creator has not answered.
 *
 * Replacing is not editing: the sent version becomes definitively
 * un-acceptable and gets a new link, so a creator sitting on the old one is
 * locked out. The brand has to say so out loud before the composer opens.
 */
export function DisplayRightsReplaceNotice({
  onConfirm,
  onCancel,
}: DisplayRightsReplaceNoticeProps) {
  const { t } = useTranslation();

  return (
    <VStack align="stretch" gap="4" data-testid="display-rights-replace-notice">
      <Alert
        status="warning"
        variant="surface"
        title={t('displayRights.replace.title')}
        icon={<WarningTriangle width={16} height={16} />}
      >
        {t('displayRights.replace.description')}
      </Alert>
      <VStack align="stretch" gap="2">
        <Button
          width="full"
          colorPalette="primary"
          fontWeight="semibold"
          onClick={onConfirm}
          data-testid="display-rights-replace-confirm"
        >
          {t('displayRights.replace.confirmCta')}
        </Button>
        <Button width="full" variant="ghost" size="sm" onClick={onCancel}>
          {t('common.cancel')}
        </Button>
      </VStack>
    </VStack>
  );
}
